import { Pipe, PipeTransform } from '@angular/core';
import { VehicleAtLocationLoadingStatus } from '../../../../global/types/vehicle-at-location';

export const vehicleOnYardFunction = {
  _mapVehicleOnYardStatus: new Map<VehicleAtLocationLoadingStatus, string>([
    [VehicleAtLocationLoadingStatus.available, 'Available'],
    // TODO uncomment if there is need for departed status to be shon
    // [VehicleAtLocationLoadingStatus.departed, 'Departed'],
    [VehicleAtLocationLoadingStatus.loadingFinished, 'Loading Finished'],
    [VehicleAtLocationLoadingStatus.loadingStarted, 'Loading Started'],
    [VehicleAtLocationLoadingStatus.pgiCompleted, 'PGI Completed'],
  ]),
};

@Pipe({
  name: 'vehicleOnYardStatusPipe',
})
export class VehicleOnYardStatusPipe implements PipeTransform {
  transform(value: VehicleAtLocationLoadingStatus, ...args): string {
    return vehicleOnYardFunction._mapVehicleOnYardStatus.get(value);
  }
}
